/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespContainerNotListed_item$ref = any;
type PdpRespContainerNotListed_similarGridItems$ref = any;
type PdpRespContainerNotListed_user$ref = any;
type PdpRespContainerNotListed_viewer$ref = any;
type PdpRespContainer_displayInfo$ref = any;
type PdpRespContainer_item$ref = any;
type PdpRespContainer_sellerItems$ref = any;
type PdpRespContainer_shipment$ref = any;
type PdpRespContainer_shipmentQuote$ref = any;
type PdpRespContainer_similarGridItems$ref = any;
type PdpRespContainer_similarLandingItems$ref = any;
type PdpRespContainer_transactions$ref = any;
type PdpRespContainer_user$ref = any;
type PdpRespContainer_viewer$ref = any;
type PdpRespContainer_vipUserRelationship$ref = any;
type PdpSharedLayout_user$ref = any;
type PdpSharedLayout_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespLayout_viewer$ref: FragmentReference;
export type PdpRespLayout_viewer = {|
  +user?: ?{|
    +$fragmentRefs: PdpRespContainer_user$ref & PdpRespContainerNotListed_user$ref & PdpSharedLayout_user$ref
  |},
  +vipUserRelationships?: ?$ReadOnlyArray<?{|
    +$fragmentRefs: PdpRespContainer_vipUserRelationship$ref
  |}>,
  +item: ?{|
    +isListingNotListed: ?boolean,
    +seller: ?{|
      +isInternal: ?boolean
    |},
    +displayInfo?: ?{|
      +$fragmentRefs: PdpRespContainer_displayInfo$ref
    |},
    +similarLandingItems?: ?{|
      +$fragmentRefs: PdpRespContainer_similarLandingItems$ref
    |},
    +similarGridItems?: ?{|
      +$fragmentRefs: PdpRespContainer_similarGridItems$ref & PdpRespContainerNotListed_similarGridItems$ref
    |},
    +sellerItems?: ?{|
      +$fragmentRefs: PdpRespContainer_sellerItems$ref
    |},
    +$fragmentRefs: PdpRespContainer_item$ref & PdpRespContainerNotListed_item$ref,
  |},
  +relevantShippingInfo?: ?{|
    +shipmentQuote: ?{|
      +$fragmentRefs: PdpRespContainer_shipmentQuote$ref
    |},
    +shipment: ?{|
      +$fragmentRefs: PdpRespContainer_shipment$ref
    |},
  |},
  +transactions: ?{|
    +$fragmentRefs: PdpRespContainer_transactions$ref
  |},
  +$fragmentRefs: PdpRespContainer_viewer$ref & PdpRespContainerNotListed_viewer$ref & PdpSharedLayout_viewer$ref,
  +$refType: PdpRespLayout_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId",
  "type": "String!"
},
v1 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId",
  "type": "String"
},
v2 = {
  "kind": "Variable",
  "name": "filterOutLessSellableItems",
  "variableName": "filterOutLessSellableItemsTest",
  "type": "Boolean"
};
return {
  "kind": "Fragment",
  "name": "PdpRespLayout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "itemId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "isClient",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "fetchPdp",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "filterOutLessSellableItemsTest",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "relationshipUserIds",
      "type": "[String]!"
    },
    {
      "kind": "RootArgument",
      "name": "itemIds",
      "type": "[String]"
    },
    {
      "kind": "RootArgument",
      "name": "userIds",
      "type": "[String]"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespContainer_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespContainerNotListed_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedLayout_viewer",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "item",
      "storageKey": null,
      "args": [
        (v0/*: any*/)
      ],
      "concreteType": "Item",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpRespContainer_item",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "PdpRespContainerNotListed_item",
          "args": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isListingNotListed",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "seller",
          "storageKey": null,
          "args": null,
          "concreteType": "Seller",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isInternal",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "fetchPdp",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": "sellerItems",
              "name": "moreLikeThis",
              "storageKey": "moreLikeThis(first:4,seller:\"INCLUDE\")",
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 4,
                  "type": "Int"
                },
                {
                  "kind": "Literal",
                  "name": "seller",
                  "value": "INCLUDE",
                  "type": "seller"
                }
              ],
              "concreteType": "moreLikeThisConnection",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "PdpRespContainer_sellerItems",
                  "args": null
                }
              ]
            }
          ]
        },
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "isClient",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "displayInfo",
              "storageKey": null,
              "args": [
                (v1/*: any*/),
                {
                  "kind": "Literal",
                  "name": "page",
                  "value": "pdp",
                  "type": "PageDisplayEnum"
                }
              ],
              "concreteType": "ItemDisplayInfo",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "PdpRespContainer_displayInfo",
                  "args": null
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": "similarLandingItems",
              "name": "moreLikeThis",
              "storageKey": null,
              "args": [
                (v2/*: any*/),
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 12,
                  "type": "Int"
                }
              ],
              "concreteType": "moreLikeThisConnection",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "PdpRespContainer_similarLandingItems",
                  "args": null
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": "similarGridItems",
              "name": "moreLikeThis",
              "storageKey": null,
              "args": [
                (v2/*: any*/),
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 8,
                  "type": "Int"
                },
                {
                  "kind": "Literal",
                  "name": "seller",
                  "value": "EXCLUDE",
                  "type": "seller"
                }
              ],
              "concreteType": "moreLikeThisConnection",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "PdpRespContainer_similarGridItems",
                  "args": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "PdpRespContainerNotListed_similarGridItems",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "transactions",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userIds",
          "type": "[String]"
        },
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemIds",
          "type": "[String]"
        }
      ],
      "concreteType": "TransactionConnection",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpRespContainer_transactions",
          "args": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isClient",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "relevantShippingInfo",
          "storageKey": null,
          "args": [
            (v1/*: any*/),
            (v0/*: any*/)
          ],
          "concreteType": "QueryRelevantShippingInfo",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "shipmentQuote",
              "storageKey": null,
              "args": null,
              "concreteType": "ShipmentQuote",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "PdpRespContainer_shipmentQuote",
                  "args": null
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "shipment",
              "storageKey": null,
              "args": null,
              "concreteType": "Shipment",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "PdpRespContainer_shipment",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchUser",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId",
              "type": "String!"
            }
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_user",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainerNotListed_user",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "PdpSharedLayout_user",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": "vipUserRelationships",
          "name": "userRelationships",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "relationshipType",
              "value": "VIP",
              "type": "relationshipType!"
            },
            {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "relationshipUserIds",
              "type": "[String]!"
            }
          ],
          "concreteType": "UserRelationship",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_vipUserRelationship",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'bc0b4adf6398dc2fb6887abb8db8ec3b';
module.exports = node;
